<template>
  <div>
    <Collapse v-model="value1">
      <Panel name="1">
        查询条件
        <div slot="content">
          <Form :model="formItem" :label-width="80">
            <Row>
              <Col span="6">
              <FormItem label="设备型号">
                <Select v-model="formItem.input" placeholder="设备型号">
                  <Option v-for="(item, index) in devicemodelList" :key="index"
                          :value=item>
                    {{item}}
                  </Option>
                </Select>
              </FormItem>
              </Col>

              <Col span="6">
              <FormItem label="版本名称">
                <Input v-model="formItem.name" placeholder="版本名称" />
              </FormItem>
              </Col>
              <Col span="12">
              <Row type="flex" justify="end">
                <FormItem class="btnC">
                  <Button type="primary" icon="ios-search" @click="handleListVersion('1')">查询</Button>
                </FormItem>
                <FormItem class="btnR">
                  <Button type="primary" icon="ios-refresh" @click="rest">重置</Button>
                </FormItem>
              </Row>
              </Col>
            </Row>

          </Form>
        </div>
      </Panel>
    </Collapse>
    <div style="margin-top: 30px">
    <Table border :columns="columns7" :data="versionList"></Table>
    <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" show-elevator style="float:right;margin-top:20px;" @on-change="handlePage" />
    </div>
    <Drawer
    title="编辑"
    v-model="editFormVisible"
    width="620"
    :mask-closable="false"
    :styles="styles"
  >
    <Form :model="editForm" :rules="ruleValidate" ref="formValidate">
      <Row :gutter="32">
        <Col span="12">
        <FormItem label="名称" label-position="top">
          <Input v-model="editForm.name" placeholder="" disabled />
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="版本号" label-position="top"  prop="version">
          <Input v-model="editForm.version" placeholder="" />
        </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="24">
        <FormItem label-position="top" v-for="(item, index) in descList" :key="index" :label="showText(item.lang)">
          <Input type="textarea" v-model="descItem[index]" :row="4" />
        </FormItem>
        </Col>
      </Row>

      <Row :gutter="32">
        <Col span="12">
        <FormItem label="指定基础版本" label-position="top">
          <Input v-model="eitbaseversion" placeholder="请输入指定基础版本" />
        </FormItem>
        </Col>

        <Col span="12">
        <FormItem label="选择指定基础版本" label-position="top">
          <Select v-model="editForm.baseversiononelist" placeholder="请选择指定基础版本"  @on-change="versionchangeval">
          <Option v-for="(item, index) in baseversionList" :key="index"
                  :value=item>
            {{item}}
          </Option>
        </Select>
        </FormItem>
        </Col>

      </Row>

      <Row :gutter="32">
        <Col span="12">
        <FormItem label="MD5" label-position="top">
          <Input v-model="editForm.md5" placeholder="" disabled />
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="大小" label-position="top">
          <Input v-model="editForm.fileSize" placeholder="" disabled />
        </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
        <FormItem label="创建时间" label-position="top">
          <Input v-model="editForm.createTime" placeholder="" disabled/>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="修改时间" label-position="top">
          <Input v-model="editForm.updateTime" placeholder="" disabled/>
        </FormItem>
        </Col>
      </Row>
    </Form>
    <div class="version-drawer-footer">
      <Button style="margin-right: 8px" @click="editFormVisible = false">取消</Button>
      <Button type="primary" @click="editSubmit">确认</Button>
    </div>
  </Drawer>

        <Drawer :closable="false" width="640" v-model="detailVisible">
            <p :style="pStyle">详情</p>
            <Divider />
            <div class="version-drawer-profile" :model="detailForm">
              <Row>
                <Col span="24">
                boardId: {{detailForm.boardId}}
                </Col>
              </Row>
              <Row>
                <Col span="24">
                设备类型: {{detailForm.deviceType}}
                </Col>
              </Row>
              <Row>
                <Col span="24">
                设备型号: {{detailForm.deviceModel}}
                </Col>
              </Row>
                <Row>
                    <Col span="24">
                        升级包名称: {{detailForm.name}}
                    </Col>
                </Row>
              <!--<Row>-->
              <!--<Col span="24">-->
              <!--升级包语言: {{detailForm.lang}}-->
              <!--</Col>-->
            <!--</Row>-->
              <Row v-for="(item, index) in langList" :key="index">
                <Col span="24">
                {{showlang(item.lang)}}
                </Col>
              </Row>

              <Row>
                <Col span="24">
                服务器名称: {{detailForm.ftp.ftpName}}
                </Col>
              </Row>
                <Row>
                    <Col span="24">
                        版本号: {{detailForm.version}}
                    </Col>
                </Row>
              <Row>
                <Col span="24">
                指定基础版本: {{detailForm.baseVersion}}
                </Col>
              </Row>
              <Row>
                <Col span="24">
                客户编号: {{detailForm.customer}}
                </Col>
              </Row>
              <Row>
                <Col span="24">
                客户版本编号: {{detailForm.versionId}}
                </Col>
              </Row>
                <Row v-for="(item, index) in descList" :key="'info2-'+index">
                    <Col span="24">
                        {{showText(item.lang)}}: {{item.desc}}
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        MD5: {{detailForm.md5}}
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        大小: {{detailForm.fileSize}}
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        创建时间: {{detailForm.createTime}}
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        修改时间: {{detailForm.updateTime}}
                    </Col>
                </Row>
            </div>
        </Drawer>
    <Modal
      v-model="modal1"
      title="提示信息"
      @on-ok="ok"
      @on-cancel="cancel">
      <p>确定要删除该条升级包信息吗？</p>
    </Modal>
  </div>
</template>
<script>
import {getdevicemodelList, getqueryuploadList, getVersionList, removeVersion, editVersion, getdeviceversion} from '@/api/data'
export default {
  data () {
    const validateVersion = (rule, value, callback) => {
      let reg = /^([1-9]\d{1,2}|[1-9])(.([1-9]\d{1,2}|\d)){2,3}-\d{1,10}$/;
      console.log(666);
      if (!reg.test(value)) {
        callback(new Error('版本号格式不正确'))
      } else {
        callback()
      }
    }
    return {
      pageNum: 1,
      pageSize: 10,
      pageTotal: 0,
      value1: '1',
      versionList: [],
      devicemodelList: [],
      formItem: {
        input: '',
        name: ''
      },
      delid: '',
      modal1: false,
      baseversionList: [],
      editFormVisible: false,
      detailVisible: false,
      descList: [],
      langList: [],
      descItem: [],
      langItem: [],
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        fontSize: '16px',
        paddingBottom: '53px',
        position: 'static'
      },
      pStyle: {
        fontSize: '16px',
        color: '#17233d',
        lineHeight: '20px',
        display: 'block',
        fontWeight: 'bold'
      },
      editForm: {
        id: '',
        name: '',
        version: '',
        desc: '',
        md5: '',
        fileSize: '',
        createTime: '',
        updateTime: '',
        baseversiononelist: ''

      },
      eitbaseversion: '',
      detailForm: {
        ftpId: '',
        ftp: {
          ftpName: ''
        },
        versionId: '',
        lang: '',
        boardId: '',
        customer: '',
        deviceModel: '',
        deviceType: '',
        name: '',
        version: '',
        baseVersion: '',
        desc: '',
        md5: '',
        fileSize: '',
        createTime: '',
        updateTime: ''
      },

      ruleValidate: {
        version: [
          {required: true,  trigger: 'blur', message: '请输入版本号'},
          {validator: validateVersion, trigger: 'blur'}
        ],
      },


      columns7: [
        {
          type: 'index',
          indexMethod: (row) => {
            return row.id
          },
          width: 60,
          align: 'center'
        },
        {
          title: '设备型号',
          algin: 'center',
          key: 'deviceModel',
          width: 160
        },
        {
          title: '名称',
          key: 'name',
          width: 360,
          algin: 'center',
          render: (h, params) => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'person'
                }
              }),
              h('strong', params.row.name)
            ])
          }
        },
        {
          title: '版本号',
          algin: 'center',
          key: 'version',
          width: 160
        },
        {
          title: 'MD5',
          algin: 'center',
          key: 'md5'
        },
        {
          title: '大小(KB)',
          width: 100,
          algin: 'center',
          key: 'fileSize',
          render: (h, params) => {
            let self = this
            return h('div', Math.ceil(self.versionList[params.index].fileSize / 1024))
          }
        },
        {
          title: '创建时间',
          algin: 'center',
          key: 'createTime',
          render: (h, params) => {
            let self = this
            return h('div', self.versionList[params.index].createTime)
          }
        },
        {
          title: '修改时间',
          algin: 'center',
          key: 'updateTime',
          render: (h, params) => {
            let self = this
            return h('div', self.versionList[params.index].updateTime)
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let self = this
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      self.handleDetail(params.row)
                    }
                  }
                },
                '详情'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      self.handleEdit(params.row)
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.modal1 = true
                      this.delid = params.row.id
                      //                      self.handleDel(params.row.id)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
  mounted () {
    this.handledealerlist()// 套餐查询
  },
  methods: {

    show (index) {
      this.$Modal.info({
        title: '版本信息',
        content: `Name：${this.versionList[index].name}<br>Age：${
          this.versionList[index].age
        }<br>Address：${this.versionList[index].address}`
      })
    },
    rest () { // 重置相当于查询所有
      this.formItem.input = ''
      this.formItem.name = ''
      this.handleListVersion('1')
    },
    ok () {
      this.handleDel(this.delid)
    },
    cancel () {
      this.$Message.info('取消删除')
    },
    handleDel (index) {
      let param = {id: index}
      removeVersion(param).then((res) => {
        let stutas = res.data.meta.success
        if (stutas) {
          this.$Message.success('删除成功')
        } else {
          this.$Message.error('删除失败')
        }
        this.handleListVersion()
      })
    },

    handleEdit (row) {
      this.editFormVisible = true
      this.descItem.length = 0
      this.langItem.length = 0
      this.descList = JSON.parse(row.desc)
      let descLen = this.descList.length
      for (let i = 0; i < descLen; i++) {
        this.descItem.push(this.descList[i].desc)
        this.langItem.push(this.descList[i].lang)
      }
      //      this.editForm = Object.assign({}, row);
      this.editForm.id = row.id
      this.editForm.name = row.name
      this.editForm.version = row.version
      this.editForm.desc = row.desc
      this.editForm.md5 = row.md5
      this.editForm.fileSize = row.fileSize
      this.editForm.createTime = row.createTime
      this.editForm.updateTime = row.updateTime
      this.eitbaseversion = row.baseVersion
      this.geteitversionList(row.boardId, row.deviceType)
    },

    versionchangeval (val) {
      this.eitbaseversion = val
    },

    geteitversionList (boardId, deviceType) {
      let para = {}
      para.boardId = boardId,
      para.deviceType = deviceType,
      getdeviceversion(para).then((res) => {
        this.baseversionList = []
        this.baseversionList = res.data.data
      })
    },
    handleDetail (row) {
      console.log(row)
      this.detailVisible = true
      this.descList = JSON.parse(row.desc)
      this.langList = JSON.parse(row.lang)
      this.detailForm = Object.assign({}, row)
    },

    handledealerlist () {
      getdevicemodelList({queryType:0}).then((res) => {
        this.devicemodelList = []
        this.devicemodelList = res.data.data
        this.handleListVersion('1')// 套餐查询
      })
    },
    editSubmit () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
      let descList = []
      for (let i = 0; i < this.descList.length; i++) {
        let desc = {}
        desc.lang = this.langItem[i]
        desc.desc = this.descItem[i]
        descList.push(desc)
      }
      let desc = JSON.stringify(descList)
      let param = {
        id: this.editForm.id,
        name: this.editForm.name,
        version: this.editForm.version,
        desc: desc,
        baseVersion: this.eitbaseversion,
        md5: this.editForm.md5,
        fileSize: this.editForm.fileSize,
        createTime: this.editForm.createTime,
        updateTime: this.editForm.updateTime
      }
      editVersion(param).then((res) => {
        let status = res.data.meta.success
        this.editForm.baseversiononelist = ''
        if (status) {
          this.handleListVersion()
          this.$Message.success('修改成功')
        } else {
          this.$Message.error('修改失败')
        }
        this.editFormVisible = false
      })
        }
      })
    },
    handlePage (num) {
      this.pageNum = num
      this.handleListVersion()
    },
    handleListVersion (param) {
      if (param == '1') {
        this.pageNum = 1
      }
      let para = {}
      para.page = this.pageNum,
      para.rows = this.pageSize,
      para.fileName = this.formItem.name,
      para.deviceModel = this.formItem.input,
      para.queryType = 0,
      getqueryuploadList(para).then((res) => {
        this.pageTotal = res.data.data.total
        this.versionList = res.data.data.list
        //        console.log(res);
      })
    },
    showText (lang) {
      let langJson = [
        {
          'lang': 'cn',
          'text': '版本描述--中文简体'
        },
        {
          'lang': 'tw',
          'text': '版本描述--中文繁体'
        },
        {
          'lang': 'en',
          'text': '版本描述--英语'
        },
        {
          'lang': 'vi',
          'text': '版本描述--越南语'
        },
        {
          'lang': 'ja',
          'text': '版本描述--日语'
        },
        {
          'lang': 'tr',
          'text': '版本描述--土耳其语'
        },
        {
          'lang': 'de',
          'text': '版本描述--德语'
        },
        {
          'lang': 'it',
          'text': '版本描述--意大利语'
        },
        {
          'lang': 'ko',
          'text': '版本描述--韩语'
        },
        {
          'lang': 'th',
          'text': '版本描述--泰语'
        },
        {
          'lang': 'fr',
          'text': '版本描述--法语'
        },
        {
          'lang': 'pt',
          'text': '版本描述--葡萄牙语'
        },
        {
          'lang': 'es',
          'text': '版本描述--西班牙语'
        },
        {
          'lang': 'pl',
          'text': '版本描述--波兰语'
        },
        {
          'lang': 'id',
          'text': '版本描述--印尼语'
        },
        {
          'lang': 'ru',
          'text': '版本描述--俄语'
        },
        {
          'lang': 'ar',
          'text': '版本描述--阿拉伯语'
        },
        {
          'lang': 'he',
          'text': '版本描述--希伯来语'
        },
        {
          'lang': 'pe',
          'text': '版本描述--波斯语'
        },
        {
          'lang': 'gr',
          'text': '版本描述--希腊语'
        },
        {
          'lang': 'cz',
          'text': '版本描述--捷克语'
        }]
      for (let i = 0; i < langJson.length; i++) {
        if (lang === langJson[i].lang) {
          return langJson[i].text
        }
      }
    },

    showlang (lang) {
      let langJson = [
        {
          'lang': 'Korean',
          'text': '升级包语言--韩语'
        },
        {
          'lang': 'Vietnamese',
          'text': '升级包语言--越南语'
        },
        {
          'lang': 'English',
          'text': '升级包语言--英语'
        },
        {
          'lang': 'Indonesian',
          'text': '升级包语言--印尼语'
        },
        {
          'lang': 'Polish',
          'text': '升级包语言--波兰语'
        },
        {
          'lang': 'tr',
          'text': '升级包语言--土耳其语'
        },
        {
          'lang': 'German',
          'text': '升级包语言--德语'
        },
        {
          'lang': 'Italian',
          'text': '升级包语言--意大利语'
        },
        {
          'lang': 'All',
          'text': '升级包语言--多国语言'
        },
        {
          'lang': 'Hebrew',
          'text': '升级包语言--希伯来语'
        },
        {
          'lang': 'Japanese',
          'text': '升级包语言--日语'
        },
        {
          'lang': 'Portuguese',
          'text': '升级包语言--葡萄牙语'
        },
        {
          'lang': 'French',
          'text': '升级包语言--法语'
        },
        {
          'lang': 'Spanish',
          'text': '升级包语言--西班牙语'
        },
        {
          'lang': 'Turkish',
          'text': '升级包语言--土耳其语'
        },
        {
          'lang': 'Greek',
          'text': '升级包语言--希腊语'
        },
        {
          'lang': 'Thai',
          'text': '升级包语言--泰语'
        },
        {
          'lang': 'Czech',
          'text': '升级包语言--捷克语'
        },
        {
          'lang': 'Persian',
          'text': '升级包语言--波斯语'
        },
        {
          'lang': 'SimpChinese',
          'text': '升级包语言--简体中文'
        },
        {
          'lang': 'Russian',
          'text': '升级包语言--俄语'
        },
        {
          'lang': 'Arabic',
          'text': '升级包语言--阿拉伯语'
        },
        {
          'lang': 'TranChinese',
          'text': '升级包语言--繁体中文'
        }
      ]
      for (let i = 0; i < langJson.length; i++) {
        if (lang === langJson[i].lang) {
          return langJson[i].text
        }
      }
    }
  }
//  created () {
//    this.handleListVersion()
//  }
}
</script>

<style>
    .version-drawer-footer{
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
    .version-drawer-profile .ivu-col{
        margin-bottom: 12px;
        font-size: 14px;
    }
    .btnR .ivu-form-item-content{
      margin-left: 0px!important;
    }

    .btnC .ivu-form-item-content{
      margin-left: 0px!important;
      margin-right: 10px;
    }
</style>
